import { render, staticRenderFns } from "./apigroupitemform.vue?vue&type=template&id=1278fa41&"
import script from "./apigroupitemform.vue?vue&type=script&lang=js&"
export * from "./apigroupitemform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports